//@ts-nocheck
import { Fragment, useEffect, useState } from "react";
import useUrlParams from "../../../../hooks/useUrlParams";
import { v4 as uuidv4 } from "uuid";
import { Form } from 'react-bootstrap';
import './Console.scss';
import useTrueTwin from "../../../../hooks/useTrueTwin";

interface RawFormProps {

}
const RawForm: React.FC<RawFormProps> = ({ }) => {
    const { truetwin_id } = useTrueTwin()
    const { mission_name, mission_id, sat_name, sat_id, truetwin_name, dashboard, scenario_name, scenario_id } = useUrlParams()
    const [rawFormData, setRawFormData] = useState("")

    useEffect(() => {
        sessionStorage.setItem('currentForm', 'raw');
        sessionStorage.setItem('type', 'RawTctm')
        setRawFormPostData(rawFormData);
        window.dispatchEvent(new Event('storageUpdate'));
    }, []);

    useEffect(() => {
        const clearFormFields = () => {
            setRawFormPostData(sessionStorage.getItem('rawBytes'))
            sessionStorage.setItem('currentForm', 'raw');
            sessionStorage.setItem('type', 'RawTctm');
        };

        window.addEventListener('clearFormFields', clearFormFields);
        return () => {
            window.removeEventListener('clearFormFields', clearFormFields);
        };
    }, []);

    useEffect(() => {
        sessionStorage.setItem('rawBytes', rawFormData);
        setRawFormPostData(rawFormData);
        window.dispatchEvent(new Event('storageUpdate'));
    }, [rawFormData]);

    const setRawFormPostData = (data) => {
        const formData = [{
            "TruetwinId": truetwin_id,
            "LinkId": "",
            "scenarioId": scenario_id,
            "Timestamp": null,
            "CommandUid": uuidv4(),
            "Type": "RawTctm",
            "ScheduleId": "default",
            "TaskId": "default",
            "sequenceData": {
                "commandDataRaw": data,
                "useRawCommand": true
            }
        }];
        sessionStorage.setItem('formData', JSON.stringify(formData));
        return formData;
    }

    const handleRawInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        try {
            setRawFormData(newValue)
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <Fragment>
            <span className="console__sub__header__white__text">Byte Stream</span>
            <Form.Control
                className="input__preview__container_big bg-transparent modal__scrollbar__white__vertical"
                type="text"
                as="textarea"
                placeholder="Enter Base64 Encoded format"
                value={rawFormData}
                rows={17}
                style={{ resize: 'none' }}
                onChange={handleRawInputChange}
                onMouseDown={(e) => { e.stopPropagation() }} // Prevents window dragging while selecting text
                onSelectStart={(e) => { e.stopPropagation() }} // Ensures text can be selected without triggering drag
            />
        </Fragment>
    )
}

export default RawForm